import React from "react";
import { connect } from "react-redux";

import PhysicalDetail from "./PhysicalDetail";
import getMyUserPhysicalProfile from "../../../../../_selectors/userSelectors/getMyUserPhysicalProfile";
const Physical = ({ userProfile, update, showToast }) => {
  return (
    <PhysicalDetail
      userProfile={userProfile}
      update={update}
      toast={showToast}
      showEdit={true}
    />
  );
};
const mapStateToProps = (state, ownProps) => ({
  userProfile: getMyUserPhysicalProfile(state)
});

export default connect(mapStateToProps)(Physical);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Physical/index.js